<!-- ================管理端-协同备课====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">协同备课列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">创建协同备课</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">学段:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">年级:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择">
                        <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">学科:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.subjectKey" placeholder="请选择">
                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">备课状态:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.status" placeholder="请选择">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="admin-search4-100 mt5">
            <div class="admin-search25">
                <div class="admin-search25-name">发布状态:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.releaseStatus" placeholder="请选择">
                        <el-option v-for="item in releaseStatusList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.title" placeholder="请输入备课名称">
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 310px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="备课状态" prop="status">
                    <template #default="scope">
                        <div>{{ formatStatus(scope.row.status) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="发布状态" prop="releaseStatus">
                    <template #default="scope">
                        <div>{{ formatReleaseStatus(scope.row.releaseStatus) }}</div>
                    </template>
                </el-table-column>
                <el-table-column min-width="200" align="center" label="备课名称" prop="title">
                    <template #default="scope">
                        <div :title="scope.row.title" @click="goDetail(scope.row)" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                
                <el-table-column width="180" align="center" label="学段·年级·学科">
                    <template #default="scope">
                        <el-text>
                            {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="主备人" prop="leadUserName" />
                <el-table-column width="140" align="center" label="协备人" prop="teamUserText">
                    <template #default="scope">
                        <div :title="scope.row.teamUserText" class="text-one">{{ scope.row.teamUserText || '--' }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="140" align="center" label="指导专家" prop="guideUserText">
                    <template #default="scope">
                        <div :title="scope.row.guideUserText" class="text-one">{{ scope.row.guideUserText || '--' }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="180" align="center" label="备课时段">
                    <template #default="scope">
                        <div>{{ formatTimeRange(scope.row) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="创建时间" prop="createTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="120" fixed="right" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="100" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="goDetail(scope.row)">查看</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status===1&&(scope.row.role == 0 || scope.row.role == 3) ">
                                        <el-text type="primary" @click="handleSubmit(scope.row)">开始备课</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status===2 && scope.row.role == 0 ">
                                        <el-text type="primary" @click="handleCA(scope.row)">上传初案</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status===3 && scope.row.role == 0">
                                        <el-text type="primary" @click="handleYT(scope.row)">上传修正案</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status===3 && scope.row.role == 0">
                                        <el-text type="primary" @click="handleSubmit(scope.row)">开始协同</el-text>
                                    </div>
                                    <div class="text-item" v-if="(scope.row.status == 2 || scope.row.status == 4) && (scope.row.role == 0 || scope.row.role == 1)">
                                        <el-text type="primary" @click="handleDiscuss(scope.row)">协同备课</el-text>
                                    </div>
                                    <div class="text-item" v-if="(scope.row.role == 0||this.role==1||this.role==2||scope.row.createUser==this.userId)&&(scope.row.status == 2 || scope.row.status == 4)">
                                        <el-text type="primary" @click="handleStop(scope.row)">停止协同</el-text>
                                    </div>
                                    <div class="text-item" v-if="(scope.row.status == 5 || scope.row.status == 3 || scope.row.status == 8) && scope.row.role == 1">
                                        <el-text type="primary" @click="handleGA(scope.row)">上传共案</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status!==9">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status===9 && (scope.row.releaseStatus===0 || scope.row.releaseStatus===3)">
                                        <el-text type="primary" @click="handleRelease(scope.row)">发布共案</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.releaseStatus===1">
                                        <el-text type="primary" @click="handleAudit(scope.row)">备课审核</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                            confirm-button-text="是"
                                            cancel-button-text="否"
                                            icon-color="#626AEF"
                                            title="确定删除该备课?"
                                            @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page="queryParams.pageNum"
                        v-model:limit="queryParams.pageSize"
                        @pagination="getList" />
        </div>

        <!-- 上传初案 -->
        <el-dialog :title="(selectRow.title || '') + '上传初案'" v-model="scCa" width="60%" @close="closeCa">
            <el-form label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="教案">
                            <el-upload v-model:file-list="selectRow.jaFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 1, lessonType: 0, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学案">
                            <el-upload v-model:file-list="selectRow.xaFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 4, lessonType: 0, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课件">
                            <el-upload v-model:file-list="selectRow.kjFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 2, lessonType: 0, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="习题">
                            <el-upload v-model:file-list="selectRow.xtFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 3, lessonType: 0, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 上传修正案 -->
        <el-dialog :title="(selectRow.title || '') + '上传修正案'" v-model="scYt" width="60%" @close="closeYt">
            <el-form label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="教案">
                            <el-upload v-model:file-list="selectRow.ytjaFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 1, lessonType: 2, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学案">
                            <el-upload v-model:file-list="selectRow.ytxaFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 4, lessonType: 2, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课件">
                            <el-upload v-model:file-list="selectRow.ytkjFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 2, lessonType: 2, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="习题">
                            <el-upload v-model:file-list="selectRow.ytxtFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 3, lessonType: 2, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 上传共案 -->
        <el-dialog :title="(selectRow.title || '') + '上传共案'" v-model="scGa" width="60%" @close="closeGa">
            <el-form label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="共案封面">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/lesson/uploadCover'" :show-file-list="false"
                                       :on-success="handleAvatarSuccess" :headers="{ token }"
                                       :data="{ lessonId: selectRow.lessonId }" :before-upload="beforeAvatarUpload">
                                <img v-if="selectRow.coverUrl" :src="selectRow.coverUrl" class="avatar" style="position:absolute" />
                                <el-icon v-else class="avatar-uploader-icon" style="font-size:100px;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="教案">
                            <el-upload v-model:file-list="selectRow.gajaFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 1, lessonType: 1, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学案">
                            <el-upload v-model:file-list="selectRow.gaxaFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 4, lessonType: 1, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课件">
                            <el-upload v-model:file-list="selectRow.gakjFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 2, lessonType: 1, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="习题">
                            <el-upload v-model:file-list="selectRow.gaxtFiles" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 3, lessonType: 1, lessionId: selectRow.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 备课审核 -->
        <el-dialog title="备课审核" v-model="scAudit" width="400px">
            <el-form label-width="80px">
                <el-form-item label="审核结果" required>
                    <el-radio-group v-model="auditResult">
                        <el-radio :label="1">同意</el-radio>
                        <el-radio :label="2">拒绝</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button type="primary" @click="submitAudit">确 定</el-button>
                <el-button @click="scAudit = false">取 消</el-button>
            </template>
        </el-dialog>
    </div>

</template>
<script>
import { lessonPageLessons, delLesson, delLessonFile, lessonSubmit, lessonStop, lessonRelease, lessonApprove, lessonRefuse } from "@/api/admin/lesson";
import { queryDict } from "@/api/admin/dict";
import { timestampToTime } from "@/utils/date";
import { serviceUrl } from "@/utils/global";

export default {
    components: {},
    name: "teamLessonIndex",
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            userId: JSON.parse(this.$storage.get("userInfo")).userId,
            timestampToTime,
            loading: false,
            total: 0,
            dataList: [],
            selectRow: {},
            scCa: false,
            scYt: false,
            scGa: false,
            scAudit: false,
            auditResult: '',
            auditLessonId: '',
            delFileList: [],
            queryParams: {
                title: '',
                status: '',
                releaseStatus: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: 0,
                pageNum: 1,
                pageSize: 10,
            },
            statusList: [
                { name: '初始', value: 1 },
                { name: '一轮研讨', value: 2 },
                { name: '初案修正', value: 3 },
                { name: '二轮研讨', value: 4 },
                { name: '共案修正', value: 5 },
                { name: '教学反思', value: 8 },
                { name: '备课完成', value: 9 },
            ],
            releaseStatusList: [
                { name: '未发布', value: 0 },
                { name: '审核中', value: 1 },
                { name: '已发布', value: 2 },
                { name: '已拒绝', value: 3 },
            ],
            natureList: [],
            periodList: [],
            gradeList: [],
            subjectList: [],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getQueryDict();
        this.getList();
    },
    mounted() {},
    methods: {
        getQueryDict() {
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data || [];
            })
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.periodList = res.data.data || [];
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList || [];
                }
            })
            this.getList();
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    (e.childrenList || []).forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList || [];
                        }
                    })
                }
            })
            this.getList();
        },
        formatStatus(status) {
            const item = this.statusList.find(s => s.value === status);
            return item ? item.name : status;
        },
        formatReleaseStatus(status) {
            const item = this.releaseStatusList.find(s => s.value === status);
            return item ? item.name : status;
        },
        formatLessonNature(val) {
            const item = this.natureList.find(s => s.dictKey == val);
            return item ? item.dictValue : val;
        },
        formatTimeRange(row) {
            if (row.beginTime && row.endTime) {
                return timestampToTime(row.beginTime) + ' 至 ' + timestampToTime(row.endTime);
            }
            return '--';
        },
        /** 查询备课列表 */
        getList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            lessonPageLessons(this.queryParams).then(res => {
                if (res.data && res.data.code == 1) {
                    this.total = res.data.data.total;
                    const list = res.data.data.list || [];
                    list.forEach(e => {
                        const teamTextList = [];
                        (e.teamUserList || []).forEach(j => {
                            teamTextList.push(j.trueName || j.expertName || '');
                        });
                        e.teamUserText = teamTextList.join('、');
                        const guideTextList = [];
                        (e.guideUserList || []).forEach(j => {
                            guideTextList.push(j.trueName || j.expertName || '');
                        });
                        e.guideUserText = guideTextList.join('、');
                        // 处理文件列表 name/url
                        const fileFields = ['jaFiles', 'xaFiles', 'kjFiles', 'xtFiles', 'ytjaFiles', 'ytxaFiles', 'ytkjFiles', 'ytxtFiles', 'gajaFiles', 'gaxaFiles', 'gakjFiles', 'gaxtFiles'];
                        fileFields.forEach(field => {
                            (e[field] || []).forEach(m => {
                                m.name = m.fileName;
                                m.url = m.fileUrl;
                            });
                        });
                    });
                    this.dataList = list;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置查询条件 */
        resetQuery() {
            this.queryParams = {
                title: '',
                status: '',
                releaseStatus: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: 0,
                pageNum: 1,
                pageSize: 10,
            };
            this.gradeList = [];
            this.subjectList = [];
            this.getList();
        },
        /** 创建备课 */
        handleCreate() {
            this.$router.push({
                path: "/teamLessonCreate",
            });
        },
        /** 编辑备课 */
        handleUpdate(row) {
            this.$router.push({
                path: "/teamLessonCreate",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        /** 备课详情 */
        goDetail(row) {
            this.$router.push({
                path: "/teamLessonDetail",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        /** 删除备课 */
        handleDelete(row) {
            delLesson({ lessonId: row.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "删除失败");
                }
            })
        },
        /** 开始备课 / 开始协同 */
        handleSubmit(row) {
            if (row.status == 3) {
                if (row.ytjaFiles.length == 0 && row.ytkjFiles.length == 0 && row.ytxtFiles.length == 0) {
                    this.$message.error("请先上传修正案");
                    return
                }
            }
            lessonSubmit({ lessonId: row.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("操作成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            })
        },
        /** 停止协同 */
        handleStop(row) {
            lessonStop({ lessonId: row.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("操作成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            })
        },
        /** 发布共案 */
        handleRelease(row) {
            lessonRelease({ lessonId: row.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("发布成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "发布失败");
                }
            })
        },
        /** 备课审核 */
        handleAudit(row) {
            this.auditLessonId = row.lessonId;
            this.auditResult = '';
            this.scAudit = true;
        },
        /** 提交审核结果 */
        submitAudit() {
            if (this.auditResult !== 1 && this.auditResult !== 2) {
                this.$message.error("请选择审核结果");
                return;
            }
            const auditApi = this.auditResult === 1 ? lessonApprove : lessonRefuse;
            auditApi({ lessonId: this.auditLessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("审核成功");
                    this.scAudit = false;
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "审核失败");
                }
            })
        },
        /** 上传初案 */
        handleCA(row) {
            this.selectRow = row;
            this.scCa = true;
        },
        /** 上传修正案 */
        handleYT(row) {
            this.selectRow = row;
            this.scYt = true;
        },
        /** 上传共案 */
        handleGA(row) {
            this.selectRow = row;
            if (!this.selectRow.coverUrl) {
                this.selectRow.coverUrl = '';
            }
            this.scGa = true;
        },
        handleRemove(file, uploadFiles) {
            if (file.url) {
                this.delFileList.push(file.url);
            }
            if (file.response && file.response.data) {
                this.delFileList.push(file.response.data);
            }
        },
        beforeJAUpload(rawFile) {
            if (!(rawFile.type == 'application/pdf' ||
                rawFile.type == 'application/vnd.ms-powerpoint' ||
                rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
                rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的');
                return false;
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M');
                return false;
            }
            return true;
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.selectRow.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败");
            }
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的');
                return false;
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M');
                return false;
            }
            return true;
        },
        closeCa() {
            this.delFileList.forEach(e => {
                delLessonFile({ fileUrl: e });
            });
            this.delFileList = [];
            this.scCa = false;
            this.getList();
        },
        closeYt() {
            this.delFileList.forEach(e => {
                delLessonFile({ fileUrl: e });
            });
            this.delFileList = [];
            this.scYt = false;
            this.getList();
        },
        closeGa() {
            this.delFileList.forEach(e => {
                delLessonFile({ fileUrl: e });
            });
            this.delFileList = [];
            this.scGa = false;
            this.getList();
        },
        /** 协同备课 */
        handleDiscuss(row) {
            const routeUrl = this.$router.resolve({
                path: "/edu/lessonDiscuss",
                query: {
                    lessonId: row.lessonId,
                }
            });
            window.open(routeUrl.href, '_blank');
        },
    },
}
</script>
<style scoped>
.name-search-btn {
    background-color: #377f7f !important;
    color: #fff !important;
}
.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    width: 270px;
    height: 152px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}
</style>
